// extracted by mini-css-extract-plugin
export var avatarContainer = "_l-0";
export var avatarTypingWave = "_l-i";
export var gray = "_l-f";
export var green = "_l-c";
export var icon = "_l-9";
export var image = "_l-1";
export var lg = "_l-6";
export var md = "_l-5";
export var presenceDot = "_l-b";
export var red = "_l-d";
export var sm = "_l-4";
export var status = "_l-a";
export var typingDot = "_l-h";
export var typingPill = "_l-g";
export var xl = "_l-7";
export var xs = "_l-3";
export var xxl = "_l-8";
export var xxs = "_l-2";
export var yellow = "_l-e";